import { ValidationKey } from '@/constants/validation-key';
import { ValidationReturn } from '@/validators/countryInstanceValidators';

export function representativeNoValidation(value: string): ValidationReturn {
    let pattern = new RegExp(/^([a-zA-Z]{2})-(\d{5,6})$/, 'g');
    let isValid = pattern.test(value);
    if (!isValid) {
        pattern = new RegExp(/^\d{5,6}$/, 'g');
        isValid = pattern.test(value);
    }
    return !isValid ? ValidationKey.InvalidMemberNumber : undefined;
}
